import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import omit from 'ramda/es/omit';
import path from 'ramda/es/path';
import i18n from 'app/i18n';

import api from 'app/actions/api';
import toFixedValue from 'app/common/lib/toFixedValue';

export const FINANCES_REQUEST = 'FINANCES_REQUEST';
export const FINANCES_SUCCESS = 'FINANCES_SUCCESS';
export const FINANCES_FAIL = 'FINANCES_FAIL';
export const FINANCES_RESET = 'FINANCES_RESET';
export const BALANCE_PARENT_SUCCESS = 'BALANCE_PARENT_SUCCESS';


const failedCafeteriaFinances = err => ({
  type: FINANCES_FAIL,
  payload: { err },
});

const receiveCafeteriaFinances = payload => ({
  type: FINANCES_SUCCESS,
  payload,
});

const requestCafeteriaFinances = ({ date, studentId }) => ({
  type: FINANCES_REQUEST,
  payload: { date, studentId },
});

const balanceSuccess = payload => ({
  type: BALANCE_PARENT_SUCCESS,
  payload,
});

export const resetCafeteriaFinances = () => ({
  type: FINANCES_RESET,
});

/**
 * Загрузить меню школы на день, в которой учится ученик
 *
 * @param studentId id ученика
 * @param date Месяц или день в ISO формате
 */
export function fetchFinances(studentId, date) {
  return async (dispatch) => {
    dispatch(requestCafeteriaFinances({ studentId, date }));
    try {
      const res = await api('cabinet/finances', 'get', { params: { student_id: studentId, date } });
      const data = pipe(
        prop('data'),
        omit(['result'])
      )(res);
      dispatch(receiveCafeteriaFinances(data));
    } catch (error) {
      dispatch(failedCafeteriaFinances(i18n.t('app:request_finances_failed')));
    }
  };
}

export function fetchBalanceParent() {
  return async (dispatch) => {
    try {
      const res = await api('account/balance', 'get');
      const balance = path(['data', 'primary_balance'], res);
      dispatch(balanceSuccess(toFixedValue(balance)));
    } catch (error) {
      dispatch(failedCafeteriaFinances(i18n.t('app:request_finances_balance')));
    }
  };
}

export const fetchBalance = () => fetchBalanceParent();
